import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
    meta: {
      title: '梅斯医学'
    }
  },
  {
    path: '/hot_title',
    name: 'hot_title',
    component: () => import(/* webpackChunkName: "hot_title" */ '../views/HotTitle/pc/index.vue'),
    meta: {
      title: '梅斯医学热点排行榜'
    }
  },
  {
    path: '/hot_title_m',
    name: 'hot_title_m',
    component: () => import(/* webpackChunkName: "hot_title_m" */ '../views/HotTitle/mobile/index.vue'),
    meta: {
      title: '梅斯医学热点排行榜'
    }
  },
  {
    path: '/news',
    name: 'news',
    component: () => import(/* webpackChunkName: "news" */ '../views/News/pc/index.vue'),
    meta: {
      title: '梅斯医学新闻快讯'
    }
  },
  {
    path: '/news_m',
    name: 'news_m',
    component: () => import(/* webpackChunkName: "news_m" */ '../views/News/mobile/index.vue'),
    meta: {
      title: '梅斯医学新闻快讯'
    }
  }
]

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
